import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const DEFAULT_DATETIME_FORMAT = "DD/MM/YYYY HH:mm";

export const browserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
};

export const isValidTimezone = (tz) => {
  if (typeof tz !== "string" || tz === "") return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch (e) {
    return false;
  }
};

export const resolveLeagueTimezone = (source) => {
  const candidates =
    typeof source === "string"
      ? [source]
      : [
          source?.resolved_tz,
          source?.tz,
          source?.timezone,
          source?.tournament_timezone,
          source?.tournament?.resolved_tz,
          source?.tournament?.tz,
        ];
  const found = candidates.find((candidate) => isValidTimezone(candidate));
  return found || browserTimezone();
};

const safeTimezone = (tz) => (isValidTimezone(tz) ? tz : browserTimezone());

export const leagueDayjs = (value, tz) => {
  const base = value === null || value === undefined || value === "" ? dayjs() : dayjs(value);
  return base.tz(safeTimezone(tz));
};

export const leagueNow = (tz) => leagueDayjs(undefined, tz).second(0).millisecond(0);

export const formatLeagueDateTime = (value, tz, format = DEFAULT_DATETIME_FORMAT) => {
  if (value === null || value === undefined || value === "") return "";
  return leagueDayjs(value, tz).format(format);
};
